import {Pipe, PipeTransform} from '@angular/core';

@Pipe( { name: 'dayDifference' } )
export class DayDifferencePipe implements PipeTransform {

    transform( startDateString: string, endDateString: string ): number {
        const startDate = new Date(startDateString);
        const endDate = new Date(endDateString);

        const dateDifference = endDate.getTime() - startDate.getTime();
        return Math.floor(dateDifference / (1000 * 60 * 60 * 24)) + 1;
    }
}
